// extracted by mini-css-extract-plugin
export var barContainer = "_15-0";
export var fillBar = "_15-5";
export var fillContainer = "_15-3";
export var overflow = "_15-7";
export var overflowContainer = "_15-4";
export var regular = "_15-6";
export var thick = "_15-1";
export var thin = "_15-2";